export function getSiblingHeight($el) {
    const el = $(this);
    const limit = parseInt(el.data('size-limit')) || 768;
    if(window.innerWidth < limit || $('html, body').hasClass('ie10-real')) return;

    $(this).siblings().height('initial');
    $(this).height('initial');
    
    if( $(this).siblings().height() >= $(this).height() ) {
        $(this).height($(this).siblings().height());
    }
    else {
        $(this).siblings().height($(this).height());
    }
}

export const isChrome = window.chrome != null && window.navigator.vendor === "Google Inc."; 
